/*
 * @Descripttion: 网络请求
 * @FilePath: /mall-wap-vue/src/utils/request.js
 * @Author: 张兴业
 * @Date: 2020-09-24 11:10:42
 * @LastEditors: hl
 * @LastEditTime: 2026-07-17 10:37:18
 */
import { extend } from "umi-request";
import { Toast } from "vant";
import { removeToken, getToken } from "./authority";

/**
 * 异常处理程序
 */
const errorHandler = error => {
  const { response } = error;
  return response;
};

/**
 * 配置request请求时的默认参数
 */
const request = extend({
  errorHandler,
  // 默认错误处理
  credentials: "include", // 默认请求是否带上cookie
  headers: {
    Accept: "application/json",
    // "App-Id": "5c5639d8-59a4-4eda-8c08-0492c5cc4d60",
    "App-Id": "340a57dc-bc76-45cb-aacb-4d667f3b029f",
    "Access-Control-Allow-Origin": "*"
  }
});

request.interceptors.request.use(async (url, options) => {
  if (options.loading !== false) {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
      loadingType: "spinner",
      className: "loading_toast"
    });
  }
  // console.log(url, options, 1111111111);
  // Toast.loading("加载中....", 0);
  // const token = getToken();
  const token = getToken();
  let { headers } = options;
  if (token) {
    headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`
    };
  }
  return {
    url,
    options: {
      ...options,
      headers
    }
  };
});

request.interceptors.response.use((response, options) => {
  if (options.loading !== false) {
    Toast.clear();
  }
  // Loading.service().close();
  // console.log(response, "response");
  // console.log(options, "options");
  // const code = response.status;
  if (options.headers.responseType === "blob") {
    return response
      .blob()
      .then(res => {
        if (res.code === 401 || res.code === 403) {
          removeToken();
          window.location.href = "/login";
        }
        if (res.code === 0) {
          Toast(res.message);
        }
        return res;
      })
      .catch(() => {
        Toast("获取数据失败，请稍后再试！");
      });
  }
  return response
    .json()
    .then(res => {
      // console.log(res);
      if (res.code === 401 || res.code === 403) {
        removeToken();
        window.location.href = "/login";
      }
      if (res.code === 0) {
        Toast(res.message);
      }
      return res;
    })
    .catch(() => {
      Toast("获取数据失败，请稍后再试！");
    });
});

export default request;
